import React, {useState, useEffect} from 'react'
import StaffImg from '../assets/staff-img.png';
import StaffImg1 from '../assets/staff-img1.gif';
import Loading from '../general/Loading';


const Users = ({ userData }) => {
      const [myUsers, setMyUsers] = useState([]);
      const [searchQuery, setSearchQuery] = useState('');
         const [loading, setLoading] = useState(false);
      
    
  // Fetch staff members on component mount
  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);

      try {
        const response = await fetch('https://api.kcmstore.in/store/get-myusers');

        setLoading(false);
        if (response.ok) {
          const data = await response.json();

          // const filteredUsers = data.filter(user => user.id !== userData.id);
const filteredUsers = data
  .filter(user => user.id !== userData.id)
  .sort((a, b) => b.id - a.id);           setMyUsers(filteredUsers);
        } else {
          setLoading(false);
          console.error('Failed to fetch users');
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching users:', error);
      }
    };

    fetchUsers();
  }, []);

  const filteredUsers = myUsers.filter(user =>
    user.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.phone.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.location.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.city.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.state.toLowerCase().includes(searchQuery.toLowerCase()) ||
    user.pincode.toLowerCase().includes(searchQuery.toLowerCase())
  );
  

  return (
    <>
                  <section className='py-4 bg-light'>
                <div className='px-3'>

                    <div className='d-flex'>
                        <p className='sec-heading'>My Users</p>
                        <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>View</span>
                    </div>

<div className='d-flex bg-white rounded-4'>
<i class="fa-solid fa-magnifying-glass text-darkblue py-3 px-3"></i>
                    <input
                    type="text"
                    className="form-input rounded-4 border-0"
                    placeholder="Search User"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  </div>

                    <div className="table-responsive bg-white rounded-4 mt-4">
                      <table className='w-100'>
                        <tr style={{borderBottom: '2px solid var(--darkblue)'}}>
                          <th className='px-3 py-3'>Customer Name</th>
                          <th className='px-3 py-3'>Mobile No</th>
                          <th className='px-3 py-3'>Password</th>
                          <th className='px-3 py-3'>Email</th>
                          <th className='px-3 py-3'>Gender</th>
                          <th className='px-3 py-3'>Address</th>
                        </tr>


                        {filteredUsers.length > 0 ? (
              filteredUsers.map((myUser, index) => (
                <tr className='text-muted fw-semibold' style={{ backgroundColor: index % 2 === 0 ? 'var(--peach)' : 'white' }}>
                      <td className='px-3 py-2'>{myUser.name || 'NA'}</td>
                      <td className='px-3 py-2'>{myUser.phone || 'NA'}</td>
                      <td className='px-3 py-2'>{myUser.pass || 'NA'}</td>
                      
                      <td className='px-3 py-2'>{myUser.email || 'NA'}</td>
                      <td className='px-3 py-2'>{myUser.gender || 'NA'}</td>
                      <td className='px-3 py-2'>{myUser.location} {myUser.city} {myUser.state} {myUser.pincode}</td>
                </tr>
              ))
            )

            : (
              <>
                <tr className='text-center'>
                  <td colSpan='5'>
                  <img src={StaffImg1} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10 my-3' alt='Staff' />
                  <p className='fw-bold'>No Users found.</p>
                  </td>
                </tr>
              </>
            )}
</table>
</div>

                    </div>
                    </section>

                    {loading && <Loading setLoading={setLoading} />}

    </>
  )
}

export default Users
